import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './edit.component.html',
    standalone: false
})
export class PluginEditPageComponent extends BaseModalPageComponent implements OnInit {
  plugin: InspectionPlugin;
  inspectionId: string;
  pointId: string;
  pluginId: string;
  processing = false;

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pluginService: InspectionPluginService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId]);

      this.pluginId = pluginId;

      this.initData();
    });
  }

  initData(): void {
    this.pluginService.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
    });
  }

  savePlugin(plugin: InspectionPlugin): void {
    this.processing = true;
    this.pluginService
      .updatePluginProperties(this.inspectionId, this.pointId, this.pluginId, {
        description: plugin.description,
        slotPath: plugin.slotPath,
        synchronizationEnabled: plugin.synchronizationEnabled
      })
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel(): void {
    this.goToBack();
  }
}
